import { useTheme } from '../contexts/ThemeContext';

/**
 * Theme-aware logo component
 * Automatically switches between dark and light theme logos
 */
export default function Logo({ className = '', alt = 'itgetsit logo' }) {
  const { currentThemeType, themeTypes } = useTheme();

  const logoSrc = currentThemeType === themeTypes.LIGHT
    ? '/logo-light.svg'
    : '/logo.svg';

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={className}
    />
  );
}
